import { baseApi } from './baseApi';
import {
  parsePortfolioErrorResponse
} from '../parsers/portfolio.parsers';

/**
 * Portfolio API service
 * Extends the base API with portfolio endpoints
 * 
 * @description
 * This API slice is ready for endpoint implementation.
 * Endpoints will be added as requirements are defined.
 */
export const portfolioApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPortfolioHoldings: builder.query({
      query: (params) => ({
        url: 'api/holdings/list',
        method: 'GET',
        params: { sortBy: params?.sortBy || 'highest_gain' }
      }),
      transformResponse: (response) => {
        return response;
      },
      providesTags: ['Portfolio']
    }),
    getPortfolioSummary: builder.query({
      query: () => ({
        url: 'api/holdings/portfolio-summary',
        method: 'GET',
      }),
      providesTags: ['Portfolio']
    }),
    getPortfolioPerformance: builder.query({
      query: (period) => ({
        url: 'api/portfolio/performance',
        method: 'GET',
        params: { period }
      }),
      providesTags: ['Portfolio']
    }),
    getAssetAllocation: builder.query({
      query: (type) => ({
        url: 'api/portfolio/asset-allocation',
        method: 'GET',
        params: { type: type ? type.toUpperCase() : 'ASSET' }
      }),
      providesTags: ['Portfolio']
    }),
    getHoldingsCards: builder.query({
      query: () => ({
        url: 'api/holdings/card',
        method: 'GET'
      }),
      providesTags: ['Portfolio']
    }),
  }),
});

// Export hooks for usage in components
// Hooks will be exported as endpoints are added
export const {
  useGetPortfolioHoldingsQuery,
  useGetPortfolioSummaryQuery,
  useGetPortfolioPerformanceQuery,
  useGetAssetAllocationQuery,
  useGetHoldingsCardsQuery,
} = portfolioApi;

